import { Badge } from "reactstrap";
import { numberSeparate } from "../../utils";

export const ConvertCurrency = ({ price }) => {
  if (!price) return price;

  return <span className="font-weight-bold">{numberSeparate(price)}</span>;
};

const Currency = ({ isNormal }) => {
  if (isNormal) return <>تومان</>;
  return (
    <Badge color="info" className="badge-dim">
      تومان
    </Badge>
  );
};

export default Currency;
